const location = window.location.href;

// ============================================
// AROOTAH.COM DOMAIN URLs (Legacy)
// ============================================
// ROOT API URLs
const apiProdURL = 'auth.arootah.com';
const apiStagingURL = 'auth-staging.arootah.com';

// DM API URLs
const dmApiProdURL = 'apps.arootah.com';
const dmApiStagingURL = 'apps-staging.arootah.com';

// GM API URLs
const gmApiProdURL = 'goals.arootah.com';
const gmApiStagingURL = 'goals-staging.arootah.com';

// HM API URLs
const hmApiProdURL = 'app.arootah.com';
const hmApiStagingURL = 'app-staging.arootah.com';

// ============================================
// DIGITALOCEAN DOMAIN URLs (New)
// ============================================
// ROOT API URLs - DigitalOcean
const apiProdURLDO = 'arootah-user-service-production-6y4ss.ondigitalocean.app';
const apiStagingURLDO = 'arootah-user-service-staging-ev7t2.ondigitalocean.app';

// DM API URLs - DigitalOcean
const dmApiProdURLDO = 'arootah-project-manager-prod-l9c4x.ondigitalocean.app';
const dmApiStagingURLDO = 'arootah-project-manager-staging-5zjm3.ondigitalocean.app';

// GM API URLs - DigitalOcean
const gmApiProdURLDO = 'arootah-goal-manager-prod-g2l9r.ondigitalocean.app';
const gmApiStagingURLDO = 'arootah-goal-manager-staging-ggg97.ondigitalocean.app';

// HM API URLs - DigitalOcean
const hmApiProdURLDO = 'arootah-habit-manager-production-re22a.ondigitalocean.app';
const hmApiStagingURLDO = 'arootah-habit-manager-staging-itze9.ondigitalocean.app';

// Determine which domain set to use based on current location
const isDigitalOceanDomain = location.includes('ondigitalocean.app');
const isDigitalOceanStaging = isDigitalOceanDomain && location.includes('-staging-');

// Select appropriate URLs based on domain
const selectedApiProdURL = isDigitalOceanDomain ? apiProdURLDO : apiProdURL;
const selectedApiStagingURL = isDigitalOceanDomain ? apiStagingURLDO : apiStagingURL;
const selectedDmApiProdURL = isDigitalOceanDomain ? dmApiProdURLDO : dmApiProdURL;
const selectedDmApiStagingURL = isDigitalOceanDomain ? dmApiStagingURLDO : dmApiStagingURL;

const selectedGmApiProdURL = isDigitalOceanDomain ? gmApiProdURLDO : gmApiProdURL;
const selectedGmApiStagingURL = isDigitalOceanDomain ? gmApiStagingURLDO : gmApiStagingURL;
const selectedHmApiProdURL = isDigitalOceanDomain ? hmApiProdURLDO : hmApiProdURL;
const selectedHmApiStagingURL = isDigitalOceanDomain ? hmApiStagingURLDO : hmApiStagingURL;

let apiURL = selectedApiProdURL;
let dmApiURL = selectedDmApiProdURL;
let gmApiURL = selectedGmApiProdURL;
let hmApiURL = selectedHmApiProdURL;

// Array of staging urls (both legacy and DigitalOcean)
const validStagingURLs = [
  'auth-staging.arootah.com',
  'localhost',
  '127.0.0.1'
];

// Checking if current url is a valid url for staging
if (process.env.NODE_ENV === 'development' || validStagingURLs.some(url => location.includes(url))) {
  apiURL = selectedApiStagingURL;
  dmApiURL = selectedDmApiStagingURL;
  gmApiURL = selectedGmApiStagingURL;
  hmApiURL = selectedHmApiStagingURL;
}
else if (isDigitalOceanStaging) {
  apiURL = selectedApiStagingURL;
  dmApiURL = selectedDmApiStagingURL;
  gmApiURL = selectedGmApiStagingURL;
  hmApiURL = selectedHmApiStagingURL;
}
else if (isDigitalOceanDomain) {
  apiURL = selectedApiProdURL;
  dmApiURL = selectedDmApiProdURL;
  gmApiURL = selectedGmApiProdURL;
  hmApiURL = selectedHmApiProdURL;
}

console.log(`${(apiURL === selectedApiProdURL || apiURL === apiProdURL) && process.env.NODE_ENV === 'production' ? '🟢' : '🟡'} API:`, apiURL);

export const ROOT_API_URL = `https://${apiURL}/api/v1/`;
export const DM_API_URL = `https://${dmApiURL}/api/v1/`;
export const GM_API_URL = `https://${gmApiURL}/api/v1/`;
export const HM_API_URL = `https://${hmApiURL}/api/v1/`;

// Frontend URLs for the different apps
export const ppURL = `https://${dmApiURL}`;
export const gmURL = `https://${gmApiURL}`;
export const hcURL = `https://${hmApiURL}`;

export const isStaging = apiURL === selectedApiStagingURL || apiURL === apiStagingURL;
export const isProduction = apiURL === selectedApiProdURL || apiURL === apiProdURL;
